import React, { useContext, useMemo } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { setClarityScenario } from '@bingads-webui-universal/clarity';
import { ReactTemplate } from '@bingads-webui-react/react-template';
import { PoliticalAdsDeclaration } from './political-ads-declaration';
import { usePoliticalAdsDeclarationLogger } from '../hooks/use-political-ads-declaration-logger';
import type { IUsePoliticalAdsLoggerProps } from '../types';

export interface CampaignPoliticalAdsDeclarationProps extends Pick<IUsePoliticalAdsLoggerProps, 'logger'> {
  onChange: (hasPoliticalAds: boolean) => void;
  disabled?: boolean;
  actionButtonText?: string;
}

export const CampaignPoliticalAdsDeclaration = (props: CampaignPoliticalAdsDeclarationProps) => {
  const {
    onChange,
    disabled,
    logger,
    actionButtonText,
  } = props;

  const i18n = useContext(I18nContext);

  const model = useMemo(() => ({
    strong: () => <strong>{i18n.getString((actionButtonText))}</strong>,
    em: (text: React.ReactNode) => <em>{text}</em>,
  }), []);

  const {
    logToggledSelection,
  } = usePoliticalAdsDeclarationLogger({
    task: 'campaign-creation',
    logger,
  });

  const handleChange = (value: boolean) => {
    setClarityScenario('IsPoliticalAdsDeclarationToggled');
    onChange(value);
  };

  return (
    <PoliticalAdsDeclaration
      onChange={handleChange}
      title={i18n.getString(_TL_('Political advertising declaration'))}
      checkboxLabel={<ReactTemplate
        model={model}
        template={i18n.getString(_TL_('By selecting {{strong}}{{/strong}}, I confirm that this campaign is {{em}}not{{/em}} intended for political advertising.'))}
      />}
      helpTopic="pop_BA_PoliticalAdvertisingDeclaration"
      disabled={disabled}
      logToggledSelection={logToggledSelection}
    />
  );
};

CampaignPoliticalAdsDeclaration.defaultProps = {
  disabled: false,
  actionButtonText: _TL_('Continue'),
};
